import moment from "moment-timezone";

import { isAccountingZero } from "@/services/mathServices";

export class LoanDeadLine {
    static selected: LoanDeadLine = null;
    static toEdit: LoanDeadLine = null;
    // component: DocumentLoanOCR;
    index: number;
    focus: boolean;
    selected: boolean;
    //
    date: string;
    capital: number;
    amountTotal: number;
    interests: number;
    insurance: number;
    capitalRestBefore: number;

    // "sentenceIndice": 21,
    //         "date": "2016-09-10",
    //         "capital": 3219.97,
    //         "amountTotal": 3239.28,
    //         "interests": 11.71,
    //         "insurance": 7.6,
    //         "capitalRestBefore": 285000,
    //         "boundingPoly": {
    //         },
    //         "lineCheck1": true,
    //         "lineCheck2": true
    //         },

    // constructor(component) {
    //     this.component = component;
    // }

    // static setSelected(loanDeadLine:LoanDeadLine) {
    //     selectedLoanDeadLine = loanDeadLine

    // }

    get errorCount() {
        let errorCount = 0;
        if (!moment(this.date).isValid()) {
            errorCount++;
        }
        if (!this.capital) {
            errorCount++;
        }
        if (!this.amountTotal) {
            errorCount++;
        }
        if (!this.interests) {
            errorCount++;
        }
        if (!this.insurance && this.insurance !== 0) {
            errorCount++;
        }
        if (!this.capitalRestBefore && this.capitalRestBefore !== 0) {
            errorCount++;
        }
        if (!isAccountingZero(this.difference)) return errorCount;
    }

    get difference() {
        return this.amountTotal - this.capital - this.interests - this.insurance;
    }

    get dateStyle() {
        if (!this.date) {
            return "color:red; font-weight:bold;";
        }
        return moment(this.date).isValid() ? "" : "color:red; font-weight:bold;";
    }

    get formatDate() {
        if (!this.date) return "";
        if (this.date.match(/[0-9]{4}\-[0-1][0-9]\-[0-3][0-9]/)) {
            const mDate = moment(this.date);
            if (!mDate.isValid()) return this.date;
            return mDate.format("DD/MM/YYYY");
        }
        return this.date;
    }

    highlightBT(state: boolean, prefix: string = "") {
        this.focus = state;
        if (state && prefix) {
            const id = prefix + "-loan-" + this.index;
            const elem = document.getElementById(id);
            if (elem) {
                elem.scrollIntoView({ block: "center", behavior: "smooth" });
            }
        }
    }
}
